import { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch  from '@mui/material/Switch';
import InfoRow from '../components/InfoRow/InfoRow';
import ListField from '../components/ListField/ListField';
import '../assets/css/styles.css';
import Scanner from '../../Scanner/Scanner';
import addressFetcher from '../../../Helpers/addressFetcher';



const creators = ["nexiode", "kerlink", "energyplus", "nas", "fonda", "algorab"];
const deviceTypes = [
  "250W Νατρίου", "18W LED", "Λαμπτήρας LED 100W", 
  "Λαμπτήρας LED 50W", "Λαμπτήρας LED 27W - CBRG3 D95-27W", 
  "Λαμπτήρας LED 12W - CBRG3 D60-12W", "Προβολέας HQI 400W",
  "Προβολέας LED 100W - EP-PLB-APL-100-4K", "Προβολέας 100W",
  "Προβολέας LED 30W - EP-UNV-50-4K", "Φωτιστικό Hg 250W", "Φωτιστικό Hg 125W", 
  "Φωτιστικό HQI 150W", "Φωτιστικό LED 60W - EP-PLS-SSL-60-4K", 
  "Φωτιστικό LED 30W - EP-STR-SSL-30-4K", "Φωτιστικό LED 30W - EP-PLS-SSL-30-4K",
  "Φωτιστικό LED 15W", "Φωτιστικό LED 12W - EP-STR-SSL-12-4K", "Φωτιστικό Νατρίου 250W",
  "Φωτιστικό Νατρίου 150W", "Φωτιστικό Νατρίου 70W", "Φωτιστικό Σώμα 30W STR",
  "Φωτιστικό Σώμα 12W STR", "Φωτιστικό Φθορίου 23W", "", "GL-NUR-W120", "GL-NUR-W042-039-N0-2 2M",
  "GL-NUR-W120-112-N0-D-2 2M"
];

const EditModal = ({ marker, onClose, addDevice, updateDevice, deleteDevice }) => {
  const [formData, setFormData] = useState({
    deviceName: "",
    deviceId : "",
    deviceUID: "",
    manufacturer: "nexiode",
    replacedType: "",
    address: "",
    type: "device",
    notes: "",
    lat: "",
    lng: "",
    deviceType: "",
    connections : []
  });
  const [isNewDevice, setIsNewDevice] = useState(false);
  const [wantToScan, setWantToScan] = useState(false);
  const [connections, setConnections] = useState([]);
  useEffect(() => {
    if (marker) {
      const markerData = marker.metrics || {};
      
      const deviceIsNew = 
        !marker.metrics || 
        Object.keys(marker.metrics).length === 0 || 
        (marker.metrics.id === undefined && marker.metrics.name === undefined);
      
      setIsNewDevice(deviceIsNew);
  
      setFormData({
        deviceName: markerData.name || "",
        deviceId : marker.id,
        deviceUID: markerData.uid || "",
        manufacturer: markerData.manufacturer || "nexiode",
        replacedType: markerData.replacedType || "",
        address: markerData.address || "",
        type: marker.type || "",
        notes: markerData.notes || "",
        lat: marker.lat || "",
        lng: marker.lng || "",
        deviceType : markerData.type || "",
        connections : []
      });
  
      if (markerData.connections) {
        setConnections(markerData.connections);
      }
    }
  }, [marker]);

  useEffect(() => {
    if (formData.lat && formData.lng && !formData.address) {
      (async () => {
        const address = await addressFetcher(formData.lat, formData.lng);
        if (address) {
          setFormData(prev => ({ ...prev, address }));
        }
      })();
    }
  }, [formData.lat, formData.lng]);
  
  
  

  if (!marker) return null;

  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleListChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const DeviceAction = async (action, data) => {
    const wasSuccess = await action(data);
    if (wasSuccess) onClose();
  }

const handleScan = (text) => {

  const cleaned = text.trim()
  const deviceId = cleaned.includes("/") ? cleaned.substring(cleaned.lastIndexOf("/") + 1) : cleaned;

  setFormData(prev => ({
    ...prev,
    deviceName: deviceId,
    deviceUID: deviceId,
  }));

  setWantToScan(false);
};

  const type = marker.metrics.isFop
  ? "ΦΟΠ"
  : marker.metrics.isPillar
    ? "Πίλαρ"
    : "Συσκευή";

  return (
    <Modal 
      open={!!marker} 
      onClose={onClose} 
      disableEnforceFocus 
      disableAutoFocus 
      disableRestoreFocus
    >
      <Box
        className="modal-box"
        sx={{
          p: 2,
          width: { xs: '95%', sm: 500 },
          maxHeight: { xs: '90vh', sm: '80vh' },
          overflowY: 'auto',
          mx: 'auto',
          mt: { xs: 2, sm: 5 },
          borderRadius: 2,
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="h4" gutterBottom>Στοιχεία Θέσης</Typography>

        <Typography variant="h4" gutterBottom>Σκανάρετε το QR</Typography>
        <Button style={{marginBottom: "20px"}} onClick={() => setWantToScan(!wantToScan)} variant="contained" color="primary"> Σκάναρε το QR </Button>
      
        {wantToScan && <Scanner onScan={handleScan}/>}

        <ListField
          label="Κατασκευαστής"
          value={formData.manufacturer}
          onChange={(value) => handleListChange("manufacturer", value)}
          options={creators}
        />

        <TextField
          name="deviceName"
          label="Όνομα Συσκευής"
          value={formData.deviceName}
          onChange={handleChange}
          helperText="*Συμπληρώνεται μόνο όταν υπάρχει τηλεδιαχείριση."
          fullWidth
          margin="normal"
        />

        <TextField
          name="deviceUID"
          label="Αριθμός Συσκευής"
          value={formData.deviceUID}
          onChange={handleChange}
          helperText="*Συμπληρώνεται για το μαρκάρισμα της συσκευής."
          fullWidth
          margin="normal"
        />

        {isNewDevice && (
          <FormControl>
            <FormLabel id="device-type">Τύπος Συσκευής</FormLabel>
            <RadioGroup
              aria-labelledby="device-type"
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <FormControlLabel value="pillar" control={<Radio />} label="pillar" />
              <FormControlLabel value="gateway" control={<Radio />} label="gateway" />
              <FormControlLabel value="fop" control={<Radio />} label="ΦΟΠ" />
            </RadioGroup>
          </FormControl>
        )}

        {marker.type === "pillar" && connections.length > 0 && (
          <Box sx={{ maxHeight: 300, overflowY: "auto", p: 2 }}>
            {connections.map((conn, i) => (
              <Box key={i} display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <span>{conn.deviceUid || `Connection ${i + 1}`}</span>
                <Switch
                  checked={!!conn.status}
                  onChange={(e) => {
                    const updated = [...connections];
                    updated[i].status = e.target.checked;
                    setConnections(updated);
                    
                    const connectedUids = updated
                      .filter(c => c.status)
                      .map(c => c.deviceId)
                      .filter(Boolean);

                    setFormData(prev => ({
                      ...prev,
                      connections: connectedUids
                    }));
                  }}
                />
              </Box>
            ))}
          </Box>
        )}

        <Typography variant="subtitle1" gutterBottom>Συντεταγμένες</Typography>
        <InfoRow label="Latitude" value={marker.lat} />
        <InfoRow label="Longtitude" value={marker.lng} />

        <Typography variant="subtitle1" gutterBottom>Συσκευή</Typography>
        <InfoRow label="Τύπος" value={type} />

        <ListField
          label="Τύπος Συσκευής"
          options={deviceTypes}
          value={formData.deviceType}
          onChange={(value) => handleListChange("deviceType", value)}
        />

        <ListField
          label="Συσκευή που αντικαθίσταται"
          options={deviceTypes}
          value={formData.replacedType}
          onChange={(value) => handleListChange("replacedType", value)}
        />

        <TextField
          name="address"
          label="Διεύθυνση"
          value={formData.address}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <TextField
          name="notes"
          label="Παρατηρήσεις"
          value={formData.notes}
          onChange={handleChange}
          fullWidth
          margin="normal"
          multiline
          rows={4}
        />
        <DialogActions>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>

            <Button onClick={onClose} sx={{ mr: 2 }}>
              Ακύρωση
            </Button>

            {!isNewDevice && 
              <>
                <Button onClick={() => {DeviceAction(deleteDevice, marker)}} variant="contained" color="error"> Διαγραφή </Button>
                <Button onClick={() => {DeviceAction(updateDevice, formData)}} variant="contained" color="primary"> Αποθήκευση </Button>
              </>
            }

            {isNewDevice && 
              <>
                <Button onClick={() => {DeviceAction(addDevice, formData)}} variant="contained" color="primary"> Προσθήκη </Button>
              </>
            }
          </Box>
        </DialogActions>
      </Box>
    </Modal>
  );
};

export default EditModal;